import ApexCharts from "apexcharts"

const CHART_COLORS = [
  "#Ff444c",
  "#94c41c",
  "#481c74",
  "#00B0FF",
  "#FFC565",
  "#9F88B1",
  "#6F0400",
  "#C4BBAF",
  "#E2C044",
  "#F9A3A4",
  "#D7263D",
  "#7D02EB",
  "#FF9800"
]

function makeChartOptions(baseOptions) {
  const { chart, titleText, series, labels = [], isThemeDark = true, ...others } = baseOptions
  const themeMode = isThemeDark ? "dark" : "light"
  const noBackground = "#00000000"

  return {
    chart: { background: noBackground, ...chart },
    colors: CHART_COLORS,
    fill: { opacity: 0.8 },
    labels: labels,
    legend: {
      fontSize: "14px",
      height: 38,
      horizontalAlign: "center",
      onItemHover: { highlightDataSeries: true },
      position: "top",
      show: true
    },
    markers: {
      size: 6,
      strokeWidth: 2,
      shape: "circle"
    },
    noData: { text: "No data found." },
    series: series,
    theme: { mode: themeMode },
    title: {
      align: "center",
      style: {
        fontSize: "20px",
        fontWeight: "bold"
      },
      text: titleText
    },
    xaxis: {},
    yaxis: {
      min: 0,
      title: {
        text: "Count",
        rotate: -90,
        style: {
          cssClass: "apexcharts-yaxis-title",
          fontSize: "12px",
          fontFamily: "Helvetica, Arial, sans-serif",
          fontWeight: 600
        }
      }
    },
    ...others
  }
}

function makeChartObj(reference, options) {
  const chart = new ApexCharts(reference, options)
  chart.render()
  return chart
}

function updateChartObj(chart, options) {
  chart.updateOptions(options)
}

export { makeChartOptions, makeChartObj, updateChartObj }
